import { BaseService } from 'src/app/core/services/base.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TreeItem } from '@progress/kendo-angular-treeview';

@Component({
  selector: 'app-search-stock-code-ecom-menu',
  templateUrl: './search-stock-code-ecom-menu.component.html',
  styleUrls: ['./search-stock-code-ecom-menu.component.scss']
})
export class SearchStockCodeEcomMenuComponent implements OnInit {
  @Input() customerCode: string;
  @Input() salesOrderHeaderId: number;
  @Input() salesOrderNumber: string;
  @Output() stockCodeSelected: EventEmitter<any> = new EventEmitter(null);

  menu: any[] = [];
  // 'LOADING','WAITING','NO-DATA','LOADED'
  menuStatus: string = 'LOADING'
  menuProductStatus: string = 'WAITING'
  productStatus: string = 'WAITING'

  selectedMenu: any = null;
  menuProducts: any[] = [];
  productDetails: any = null;

  filters: any[] = [];
  product: any = null;
  items: any[] = [];
  selectedItem: any = null;
  imageIndex: number = 0;

  constructor(
    public baseService: BaseService
  ) { }

  ngOnInit(): void {
    this.baseService.executeCommand<any>('portal_ecom_search_dialog_config', {})
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.menu = response.data;
          this.menuStatus = 'LOADED';
        } else {
          this.menuStatus = 'NO-DATA';
        }
      });
  }

  onSelectionChange(event: TreeItem): void {
    this.productStatus = 'WAITING';
    this.menuProductStatus = 'LOADING';
    this.selectedMenu = event.dataItem;
    this.productDetails = null;
    this.imageIndex = 0;
    this.filters = [];
    this.product = null;
    this.items = [];
    this.selectedItem = null;

    this.stockCodeSelected.emit(null);

    this.baseService.executeCommand<any>('portal_ecom_search_dialog_menu_products', this.selectedMenu)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.menuProducts = response.data || [];
          if (this.menuProducts.length === 0) {
            this.menuProductStatus = 'NO-DATA';
          } else {
            this.menuProductStatus = 'LOADED';
          }
        } else {
          this.menuProducts = [];
          this.menuProductStatus = 'NO-DATA';
        }
      });
  }

  showProductDetails(product) {
    this.imageIndex = 0;
    this.filters = [];
    this.product = null;
    this.items = [];
    this.selectedItem = null;
    this.stockCodeSelected.emit(null);

    this.baseService.executeCommand<any>('portal_ecom_search_dialog_product_details', {...product, customerCode: this.customerCode, salesOrderHeaderId: this.salesOrderHeaderId, salesOrderNumber: this.salesOrderNumber})
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.productDetails = response.data;
          this.product = this.productDetails.product;
          this.filters = this.productDetails.filters || [];
          this.items = this.productDetails.items || [];
          if (this.items.length === 1) {
            this.selectedItem = this.items[0];
            this.stockCodeSelected.emit(this.selectedItem);
          }
          this.productStatus = 'LOADED';
        } else {
          this.productDetails = null;
          this.productStatus = 'NO-DATA';
        }
      });
  }

  filterChanged() {
    this.stockCodeSelected.emit(null);
    this.imageIndex = 0;
    if (this.filters.filter(f => !f.value).length === 0) {
      let filteredItems = this.items.filter(f => true);

      this.filters.forEach(filter => {
        switch (filter.code) {
          case "MATERIAL":
            filteredItems = filteredItems.filter(f => f.materialId === filter.value);
            break;

          case "FEET":
            filteredItems = filteredItems.filter(f => f.feetId === filter.value);
            break;

          case "ATTRIBUTE":
            filteredItems = filteredItems.filter(f => f.attributes && f.attributes.find(fa => fa.attributeId === filter.attributeId && fa.attributeValue === filter.value));
            break;
        }
      });

      if (filteredItems.length === 1) {
        this.selectedItem = filteredItems[0];
        this.stockCodeSelected.emit(this.selectedItem);
      }
    } else {
      this.selectedItem = null;
    }
  }
}
